import { IGoal } from "motw_core/Entity/IGoal";
import { emptyGEPStateContainer } from "../GoalEditor/GoalEditorPanel/GEPState/emptyGEPStateContainer";
import { AreEqual } from "source/app/services/Shared/ReactHelpers";

export const isNewGoal = (goal: IGoal) => {
    var isNewGoal = AreEqual(goal, emptyGEPStateContainer);
    return isNewGoal;
};
